import {QRCodeSVG} from 'qrcode.react'

import {PlayStoreLogo} from './PlayStoreLogo'
import {AppleLogo} from './AppleLogo'

export interface StoreCardProps {
  storeUrl: string
  store: 'apple-store' | 'play-store'
}

const label: Record<StoreCardProps['store'], {long: string; short: string}> = {
  'play-store': {
    long: 'im Play Store erhältlich',
    short: 'Android',
  },
  'apple-store': {
    long: 'im App Store erhältlich',
    short: 'iOS',
  },
}

export const StoreCard = ({storeUrl, store}: StoreCardProps) => (
  <a
    href={storeUrl}
    className={'flex w-full flex-col gap-spacing-40 p-spacing-32 @[400px]:p-spacing-48'}
    target={'_blank'}
    rel={'noopener noreferrer'}
  >
    <p className={'flex flex-1 flex-col self-stretch text-p1'}>
      <span className={'font-medium'}>{label[store].short}</span>
      <span>{label[store].long}</span>
    </p>
    <div className={'flex flex-row justify-between'}>
      <div className={'h-spacing-48 @[400px]:h-spacing-64'}>
        {store === 'apple-store' ? <AppleLogo /> : <PlayStoreLogo />}
      </div>
      <QRCodeSVG
        value={storeUrl}
        bgColor={'transparent'}
        className={'hidden size-spacing-48 @[289px]:block @[400px]:size-spacing-64'}
      />
    </div>
  </a>
)
